import color from "color";
import moment from "moment";
import DynamicStyle from "@/components/Common/DynamicStyle";
import ConnectionsEffectIcon from "@/components/Common/ConnectionsEffectIcon";
import AgentSignature from "@/components/Common/AgentSignature";
import ConnectionsListItemAdditionalInfo from "./ConnectionsListItemAdditionalInfo";
import AddressBookAddNewNumberForm from "@/components/AddressBook/AddressBookAddNewNumberForm";
import PopoverSmsGateway from "@/components/Sms/PopoverSmsGateway";
import SurveyPopover from "@/components/Surveys/SurveyPopover";
import { hDeepCopy } from '@/utils/helpers';

// @vue/component
export default {
  name: "ConnectionsListItem",

  components: {
    DynamicStyle,
    ConnectionsEffectIcon,
    AgentSignature,
    ConnectionsListItemAdditionalInfo,
    PopoverSmsGateway,
    SurveyPopover,
    AddressBookAddNewNumberForm,
  },

  props: {
    connection: {
      type: Object,
      default: () => ({})
    },
    projectList: {
      type: Array,
      default: () => []
    },
    connectionWithOpenSurvey: {
      type: Number,
      default: null,
    }
  },

  data() {
    return {
      isDownloadingRecordFile: false,
      isAddingRecordToPlanner: false,
      isAddPlannerRecordPopoverVisible: false,
      selectedDate: '',
      note: '',
      isNotifyAllUsers: false,
      selectedSurvey: '',
      selectedTime: '',
      isManySurveyPopoverVisible: false,
      isSingleSurveyPopoverVisible: false,
      preparedAnswersForSurvey: [],
      isSurveyLoading: false,
      isAddingToAddressBook: false,

    };
  },
  created() {
    this.selectedDate = moment().format('YYYY-MM-DD');
  },
  watch: {
    selectedDate: {
      handler() {
        if (!this.selectedDate) this.selectedDate = moment().format('YYYY-MM-DD');
      }
    },
    connectionWithOpenSurvey: {
      handler() {
        if (this.connectionWithOpenSurvey !== this.connection._id) {
          this.isManySurveyPopoverVisible = false;
          this.isSingleSurveyPopoverVisible = false;
        }
      }
    }
  },
  computed: {
    selectedDateTime() {
      return `${this.selectedDate} ${this.selectedTime}:00`
    },
    surveysList() {
      return this.$store.getters['campaign/surveysList'];
    },
    currentCallSurvey() {
      return this.$store.getters['campaign/currentCallSurvey'];
    },
    questionsList() {
      return this.$store.getters['campaign/surveyQuestions'];
    },
    isRecordInCart() {
      return this.$store.getters["record/recordsCart"].some(
        elem => elem._wh1_uuid === this.connection._wh1_uuid
      );
    },
    projectUuid() {
      return this.projectList.filter(project => this.connection._project_id === project.id)[0]
        ?.uuid;
    },
    projectDetails() {
      return this.projectList.filter(project => this.connection._project_id === project.id);
    },
    isSmsGatewayVisible() {
      return (
        this.projectList.filter(project => this.connection._project_id === project.id).length > 0 &&
        this.connection._number_a.length === 11 &&
        this.connection._number_a.slice(0, 2) === "48"
      );
    },
    dynamicStyleAccordingToStatusEffect() {
      return `
      .ConnectionsListItem--${this.connection._effect} .ConnectionsListItem__details {
        border: 1px solid ${color(this.connection._effect_color)
          .rgb()
          .fade(0.7)};
        border-left: 3px solid ${this.connection._effect_color};
        transition: all 0.3s;          
      }

      .ConnectionsListItem--${this.connection._effect} .ConnectionsListItem__details:hover {
        border: 1px solid ${this.connection._effect_color}; 
        border-left: 3px solid ${this.connection._effect_color};         
      }     
      `;
    },
    recordCountDays() {
      if (this.connection._rec_live_count) {
        const rec_count = this.connection._rec_live_count.split(" ");
        return parseInt(rec_count[0]);
      }
      return null;
    },
    userHasAccessToAdditionalDataForConnection() {
      return this.$store.getters["authorization/acl"].hasPermission("another_action_access");
    },
    userHasAccessToListenRecorod() {
      return this.$store.getters["authorization/acl"].hasPermission("listening_record");
    },
    userHasAccessToDownloadRecordFile() {
      return this.$store.getters["authorization/acl"].hasPermission("download_record");
    },
    accessPlannerInConnectionList() {
      return this.$store.getters["authorization/acl"].hasPermission("connection_list_callplanner_access");
    },
    accessSurveyForConnection() {
      return this.$store.getters["authorization/acl"].hasPermission("allow_fill_survey");
    },
    isSuccesfullCall() {
      return (
        this.connection._effect == "CALLED" ||
        this.connection._effect == "MASSDIAL4CALL" ||
        this.connection._effect == "DIALOUT" ||
        this.connection._effect == "TYPED" ||
        this.connection._effect == "FORWARDED"
      );
    },
    hasCallRecord() {
      return this.connection._filename !== null;
    },
    isSurveyPopoverLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'campaign/getSurveysList',
        'campaign/getSurveyQuestions'
      ]) || this.isSurveyLoading;
    },
    hasPermissionToAddNumber() {
      return this.$store.getters["authorization/acl"].hasPermission("allow_add_to_address_book_connection_list") && !this.connection._address_book_description;
    }
  },

  methods: {
    async refreshList() {
      await this.$store.dispatch("connections/getList");
    },
    __forceFileDownload(response, fileName) {
      const element = document.createElement("a");
      element.setAttribute("href", response.data);
      element.setAttribute("download", `${fileName}.mp3`);
      if (document.createEvent) {
        const event = document.createEvent("MouseEvents");
        event.initEvent("click", true, true);
        element.dispatchEvent(event);
      } else {
        element.click();
      }
    },
    playRecordedConnection() {
      this.$EventBus.$emit("RecordListItem/TURN_PLAYER_VISIBILITY_ON");
      this.$EventBus.$emit("RecordListItem/GET_RECORD_DETAILS", this.connection._wh1_uuid);
      this.$store.dispatch("record/getDetailsListening", this.connection._wh1_uuid);
    },
    async downloadRecordedConnection() {
      this.isDownloadingRecordFile = true;
      const response = await this.$store.dispatch("record/getDetailsDownload", {
        connection: this.connection._wh1_uuid
      });
      this.isDownloadingRecordFile = false;
      this.__forceFileDownload(response, this.connection._filename);
    },
    showConnectionsAttempsHistory() {
      this.$emit("showConnectionsAttempsHistory", this.connection._wh1_uuid);
    },
    passAsFilterParams(key, value) {
      this.$EventBus.$emit("ConnectionsListItem/FILTER_AT_SPECIFIC_VALUE", {
        key,
        value
      });
    },
    addToCart() {
      this.$store.commit("record/FILL_RECORDS_CART", this.connection);
      this.$message({
        showClose: true,
        message: "Nagranie dodane do koszyka",
        type: "success"
      });
    },
    removeFromCart() {
      this.$store.commit("record/REMOVE_FROM_RECORDS_CART", this.connection);
      this.$message({
        showClose: true,
        message: "Paczka usunięta z koszyka",
        type: "success"
      });
    },
    async addRecordToPlanner() {
      this.isAddingRecordToPlanner = true;
      const params = {
        project_uuid: this.connection._project_uuid,
        num_a: this.connection._number_a,
        call_stamp: this.selectedDateTime,
        note: this.note,
        notify_all_users: this.isNotifyAllUsers
      }
      const response = await this.$store.dispatch("callPlanner/addRecordToPlanner", params);
      if (response) {
        this.$message({
          title: 'Sukces',
          message: 'Dodano rekord do listy zaplanowanych połączeń.',
          type: 'success',
        });
        this.isAddPlannerRecordPopoverVisible = false;
        await this.$store.dispatch('callPlanner/getListCount');

      } else {
        this.$message({
          message: 'Wystąpił bład podczas dodawania do listy zaplanowanych połączeń.',
          type: 'error',
        });
      }
      this.isAddingRecordToPlanner = false;
    },
    clearForm() {
      this.isNotifyAllUsers = false;
      this.selectedDate = '';
      this.selectedTime = '';
      this.note = '';
    },
    handleGetSurveysList() {
      this.$emit('closeOtherSurveys', this.connection._id);
      this.isSingleSurveyPopoverVisible = true;
      this.getSurveysList();
    },
    async getSurveysList() {
      this.isSurveyLoading = true;
      await this.$store.dispatch('campaign/getSurveysList', this.connection._project_uuid);
      await this.$store.dispatch('campaign/getSurveyQuestionsForConnections', this.connection._wh1_uuid);
      if (this.currentCallSurvey.some(item => !!item._answer)) {
        const answersForSurveyCopy = hDeepCopy(this.currentCallSurvey);
        this.preparedAnswersForSurvey = answersForSurveyCopy.map(item => ({
          questionId: item._question_id,
          answer: item._answer
        }))
      }
      if (this.surveysList.length === 1) {
        this.selectedSurvey = this.surveysList[0].uuid;
        await this.$store.dispatch('campaign/getSurveyQuestions', this.surveysList[0].uuid);
      }
      this.isSurveyLoading = false;
    },
    async getSurveyQuestions() {
      await this.$store.dispatch('campaign/getSurveyQuestions', this.selectedSurvey);
    },
    async closeMultipleSurveyPopover() {
      await this.getSurveysList();
      this.$store.dispatch('connections/getList');
      this.isManySurveyPopoverVisible = false;
      this.selectedSurvey = '';
    },
    async closeSingleSurveyPopover() {
      await this.$store.dispatch('connections/getList');
      this.isSingleSurveyPopoverVisible = false;
    },
  }
};
